interface RatingBadgeProps {
  rating: number;
  size?: 'sm' | 'md';
}

export default function RatingBadge({ rating, size = 'md' }: RatingBadgeProps) {
  const sizeClass = size === 'sm' ? 'text-xs px-1.5 py-0.5' : 'text-sm px-2 py-1';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md bg-accent-500 text-primary-950 font-semibold ${sizeClass}`}
    >
      <i className="ri-star-fill text-[0.85em]"></i>
      {rating.toFixed(1)}
    </span>
  );
}